export const preventImplicitSubmit = (e) => {
  if (e.key !== 'Enter') return;
  const target = e.target;
  if (!target || !target.tagName) return;
  const tag = target.tagName.toUpperCase();
  if (tag === 'TEXTAREA') return;
  if (tag === 'BUTTON') return;
  if (tag === 'INPUT' && (target.type === 'submit' || target.type === 'button')) return;
  e.preventDefault();
};
